import React, { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';

import CustomizedAccordion from 'components/CustomizedAccordion';
import { sanlamDarkGrayishBlue, sanlamVeryDarkBlue } from 'Material-UI/colors';
import {
  StyledCaptions,
  ItemWrapper,
  SizedSmallSectionHeader,
  StyledList,
  StyledImg,
  AccordionDetailsCaptions,
  SizedCaptions,
} from 'containers/MRHDetailsPage/PreventionGuide/styles';
import messages from 'containers/MRHDetailsPage/messages';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const PreventionGuide: React.FC<{
  intl: IntlShape;
}> = (props) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const [expanded, setExpanded] = useState<boolean | number>(false);

  const handleChange = (index: number) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    setExpanded(isExpanded ? index : false);
  };
  const items = [
    {
      title: translate(messages.CarbonMonoxidePoisoning, props),
      icon: 'Gas',
      assureDoit: translate(messages.assureDoit, props),
      paragraph: translate(messages.CarbonMonoxidePoisingParagraph, props),
      label: "Guide de prévention_En cas d'intoxication au monoxyde de carbone",
    },
    {
      title: translate(messages.waterDamage, props),
      icon: 'Leak',
      assureDoit: translate(messages.assureDoit, props),
      paragraph: translate(messages.waterDamageParagraph, props),
      label: "Guide de prévention_En cas de dégâts d'eaux",
      list: translate(messages.waterDamageList, props),
    },
    {
      title: translate(messages.fire, props),
      icon: 'Fire',
      assureDoit: translate(messages.assureDoit, props),
      paragraph: translate(messages.fireParagraph, props),
      label: "Guide de prévention_En cas d'incendie",
      list: translate(messages.fireList, props),
    },
    {
      title: translate(messages.vol, props),
      icon: 'criminal',
      assureDoit: translate(messages.assureDoit, props),
      paragraph: translate(messages.volParagraph, props),
      label: 'Guide de prévention_En cas de vol',
      list: translate(messages.volList, props),
    },
  ];
  return (
    <Box p={3}>
      <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
        {translate(messages.preventionGuideTitle, props)}
      </SizedSmallSectionHeader>
      <SizedCaptions weight="400" color="#9797AF">
        {translate(messages.preventionGuideSubTitle, props)}
      </SizedCaptions>
      <Grid spacing={1} direction="column" container>
        {items.map((item, index) => (
          <Grid key={index} item xs>
            <CustomizedAccordion
              expanded={expanded === index}
              changeHandler={handleChange(index)}
              summary={
                <GaClickHOC
                  category={EVENT_CATEGORIES.MRH_DETAILS}
                  label={item.label}
                >
                  <ItemWrapper reverse={reverse}>
                    <StyledImg
                      alt="support-icon"
                      src={AssuranceIcon[item.icon]}
                    />
                    <StyledCaptions weight="500" color={sanlamDarkGrayishBlue}>
                      {item.title}
                    </StyledCaptions>
                  </ItemWrapper>
                </GaClickHOC>
              }
              details={
                <Box paddingX={3}>
                  <AccordionDetailsCaptions weight="400">
                    {item.assureDoit}
                  </AccordionDetailsCaptions>
                  <AccordionDetailsCaptions weight="400">
                    {item.paragraph}
                  </AccordionDetailsCaptions>

                  <StyledList>
                    {item.list &&
                      item.list.split('\n').map((detail, index) => (
                        <li key={index}>
                          <AccordionDetailsCaptions weight="400">
                            {detail}
                          </AccordionDetailsCaptions>
                        </li>
                      ))}
                  </StyledList>
                </Box>
              }
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default injectIntl(PreventionGuide);
